"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = exports.Money = exports.DateString = void 0;
var DateString = function (value) { return value; };
exports.DateString = DateString;
var Money = function (value) { return value; };
exports.Money = Money;
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
})(Currency = exports.Currency || (exports.Currency = {}));
var LessThan = function (max) {
    return function (value) {
        return value < max;
    };
};
var Between = function (min, max) {
    return function (value) {
        return value > min && value < max;
    };
};
var IsInteger = function (value) { return Math.floor(value) === value; };
var IsCents = function (value) { return IsInteger(value) && Between(0, 100)(value); };
var f = 200 + 10;
if (Between(0, 100)(f) && IsInteger(f)) {
    var b = f;
    var c = f;
    var d = f;
    console.log(b, c, d);
}
if (IsCents(f)) {
    var b = f;
    var c = f;
    var d = f;
    console.log(b, c, d);
}
//# sourceMappingURL=Common.js.map